import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

import defaultColor from './defaultColor';

export default function WebsiteIcon(props) {
  const color = props.color === 'secondary' ? '#b1b1b1' : props.color;
  return <SvgIcon {...props} viewBox="0 0 14 14" fill="none">
    <path id="Vector" stroke={color || defaultColor} fill="none" strokeLinecap="round" strokeLinejoin="round" d="M7 12.25c3.36 0 5.25 -1.89 5.25 -5.25S10.36 1.75 7 1.75 1.75 3.64 1.75 7 3.64 12.25 7 12.25" strokeWidth="1"></path>
    <path id="Vector_2" stroke={color || defaultColor} fill="none" strokeLinecap="round" strokeLinejoin="round" d="M8.93853 7c0 -2.19694 -0.67335 -4.18202 -1.93851 -5.25C5.73487 2.81798 5.06152 4.80306 5.06152 7s0.67335 4.182 1.9385 5.25C8.26518 11.182 8.93853 9.19694 8.93853 7" strokeWidth="1"></path>
    <path id="Vector 2472" stroke={color || defaultColor} fill="none" strokeLinecap="round" strokeLinejoin="round" d="M1.75 7.0001c3.50934 -0.23044 6.99066 -0.23044 10.5 0" strokeWidth="1"></path>
  </SvgIcon>
}
